<header
    class="relative shrink-0 px-4 pt-12 pb-4 text-center md:px-8 md:pt-10 md:pb-8"
>
    <button
        qpxButton
        matIconButton
        class="absolute! top-4! right-4!"
        aria-label="Close"
        (click)="onCancel()"
    >
        <ng-icon qpx name="lucideX" />
    </button>

    <h2
        mat-dialog-title
        qpxHeading
        variant="lg"
        id="publish-building-title"
        class="h-auto! justify-center! border-b-0! p-0! text-xl! md:text-[1.65rem]! font-bold! leading-tight! text-foreground!"
    >
        Publish your building. Unlock its full potential.
    </h2>
    <p qpxBody="secondary" tone="muted" class="mt-2">
        Share securely, collaborate seamlessly, and manage with confidence.
    </p>
</header>

<qpx-dialog-content
    contentClass="grid! gap-6! px-4! md:gap-9! md:px-8! pb-6! pt-0!"
>
    <qpx-publish-capabilities [rows]="capabilityRows" />

    <section class="grid gap-4" aria-label="Pricing summary">
        @if (isPricingLoading()) {
            <div
                class="grid gap-4"
                role="status"
                aria-live="polite"
                aria-label="Loading checkout pricing"
            >
                <div class="grid gap-4 md:grid-cols-2">
                    @for (item of [0, 1]; track item) {
                        <div
                            class="rounded-md border border-border px-5 py-7"
                            aria-hidden="true"
                        >
                            <div class="grid justify-items-center gap-4">
                                <qpx-skeleton
                                    width="1.25rem"
                                    height="1.25rem"
                                    borderRadius="999px"
                                    class="justify-self-start"
                                />
                                <qpx-skeleton-text
                                    width="6rem"
                                    text="heading-sm"
                                    class="max-w-28"
                                />
                                <qpx-skeleton-text
                                    width="8rem"
                                    text="display-xs"
                                    class="max-w-36"
                                />
                                <qpx-skeleton-text
                                    width="7rem"
                                    text="body-sm"
                                    class="max-w-32"
                                />
                            </div>
                        </div>
                    }
                </div>

                <div
                    class="rounded-md border border-border px-4 py-4"
                    aria-hidden="true"
                >
                    <div class="grid gap-4">
                        <qpx-skeleton-text
                            width="9rem"
                            text="heading-sm"
                            class="max-w-40"
                        />
                        <div class="grid gap-2 md:grid-cols-[1fr_auto]">
                            <qpx-skeleton-text
                                [lines]="2"
                                width="12rem"
                                lastLineWidth="5rem"
                                text="body-sm"
                                class="max-w-48"
                            />
                            <qpx-skeleton-text
                                [lines]="2"
                                width="8rem"
                                lastLineWidth="7rem"
                                text="body-sm"
                                class="max-w-36 md:justify-self-end"
                            />
                        </div>
                        <qpx-skeleton
                            height="0.5rem"
                            borderRadius="999px"
                            class="w-full"
                        />
                        <div class="grid grid-cols-3 gap-3">
                            <qpx-skeleton-text width="4rem" text="body-sm" />
                            <qpx-skeleton-text
                                width="7rem"
                                text="body-sm"
                                class="justify-self-center"
                            />
                            <qpx-skeleton-text
                                width="4rem"
                                text="body-sm"
                                class="justify-self-end"
                            />
                        </div>
                    </div>
                </div>
            </div>
        } @else if (hasPricingError()) {
            <div
                class="rounded-md border border-destructive-muted px-4 py-3"
                role="status"
            >
                <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
                    <p qpxBody class="min-w-0 flex-1">
                        Pricing could not be loaded.
                    </p>
                    <button
                        qpxButton
                        matButton="outlined"
                        size="sm"
                        (click)="reloadPricing()"
                    >
                        <span>Retry</span>
                    </button>
                </div>
            </div>
        } @else {
            <qpx-publish-plan-options
                [cards]="pricingCards()"
                [selectedCadence]="selectedCadence()"
                (selectedCadenceChange)="onSelectedCadenceChange($event)"
            />

            @if (isFallbackPricing()) {
                <aside
                    class="rounded-md border border-caution-muted p-4 pb-2 bg-caution-muted/30 text-caution-muted"
                    aria-label="Fallback pricing"
                >
                    <p
                        qpxBody="caution"
                        tone="muted"
                        size="md"
                        class="m-0 font-semibold"
                    >
                        Fallback pricing
                    </p>
                    <p qpxBody="secondary" size="md" class="m-0 mt-1">
                        {{ fallbackPricingMessage }}
                    </p>
                </aside>
            } @else if (pricingCalculationSummary(); as calculation) {
                <qpx-publish-pricing-calculation [calculation]="calculation" />
            }
        }
    </section>
</qpx-dialog-content>

<qpx-publish-checkout-actions
    [canContinue]="canContinueToCheckout()"
    [checkoutLabel]="checkoutActionLabel()"
    (continueToCheckout)="onContinueToCheckout()"
/>
